<template>
  <div>
    <template class="" v-if="isDonationInstructionShow">
      <div class="donation-instration">
        <button type="button" class="btn-empty-wrapper mt-10 ml-6" @click="donationInstructionAction">
          <Close icon="back" />
        </button>
        <DonationInstruction />
      </div>
    </template>
    <div v-if="!isDonationInstructionShow" class="relative dashboard-page">
      <template>
        <template v-if="!isSingleItem">
          <div class="page-logo-container flex justify-center items-center fixed left-0 top-0 pb-4 px30">
            <div class="image-wrapper flex">
              <img class="page-logo" v-if="$getState('corporation')['is']" :src="$getState('corporation')['dark_logo']"
                :alt="corporationTitle" />
              <img v-else class="page-logo" :srcset="`${backgroundSrc}, ${backgroundSrc}`" :src="backgroundSrc"
                alt="Thrive" />
              <span class="video-play-button flex" @click="videoModelAction">
                <img class="page-play-icon" :srcset="`${logo}, ${logo}`" :src="logo" alt="Thrive" />
              </span>
            </div>
          </div>
        </template>

        <div class="" v-if="showModel">
          <VideoModel @showModel="videoModelAction" v-if="showModel" />
        </div>

        <div class="page-content-container">
          <div v-if="!isSingleItem" class="empty-block opacity-0"></div>
          <div v-if="!isSingleItem" class="page-content px30 bg-white relative z-10">
            <div class="user-info flex items-center">
              <span class="user-avatar">
                <img v-if="$user('avatar') && $user('has_avatar')" :src="$user('avatar')" />
                <UserAvatar v-else />
              </span>
              <span class="user-name font-bold text-20 text-text tracking-normal text-content">
                <p class="text-primary">
                  Hi 👋
                </p>
                <p class="text-content">
                  {{ $user("name") }}
                </p>
              </span>
              <!-- <span v-else class="user-name font-bold text-20 text-text tracking-normal text-content">
                <p class="text-primary">Hi 👋</p>
                <p>{{ $user("name") }}</p>
              </span> -->
            </div>
            <div class="my-giving-section">
              <div class="flex justify-between">
                <div class="flex relative">
                  <h3
                    class="flex-grow grow-color-text text-content font-bold text-20 tracking-normal leading-tight pr-2">
                    <span class="text-primary">
                      {{ $t("My") }}
                    </span>
                    <span class="text-secondary">{{ $t("Giving") }}</span>
                  </h3>
                  <img class="information-icon back-icon ml-1" :srcset="`${backIcon}, ${backIcon}`" :src="`${backIcon}`"
                    alt="Thrive" width="auto" height="auto" @click="donationInstructionAction" />
                </div>
                <router-link :to="{
                  name: 'Giving',
                  params: { back: '/giving' }
                }" class="text-14 tracking-normal text-cause_text">
                  <span class="flex text-content">
                    {{ $t("Details") }}
                    <svg class="icon-color back-icon ml-1 feather feather-arrow-right" fill="none" height="24"
                      stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <line x1="5" x2="19" y1="12" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                    <!-- <img class="back-icon ml-1" :srcset="`${chevronLeft}, ${chevronLeft}`" :src="chevronLeft"
                      alt="Thrive" width="auto" height="auto" /> -->
                  </span>
                </router-link>
              </div>
              <p class="tracking-normal text-14 text-text opacity-60 mb-5">
                {{ $t("Donation summary") }}
              </p>
              <div class="pb-5">
                <!-- Giving_new.vue -->
                <Giving />
              </div>
            </div>
          </div>
          <div id="post" class="shop-save-section bg-white relative z-10 px-7 py-4"
            v-if="$store.state.typeAppFilter != 'partnerSingle'">
            <CurrentLocation />
          </div>
          <template v-if="$store.state.typeAppFilter === 'partnerSingle'">
            <PartnerSingle :cause="$store.state.singleCause" :click-handler="backCauseFunc"></PartnerSingle>
          </template>
          <div id="post" v-if="$store.state.typeAppFilter != 'partnerSingle' && $getState('isPosts')"
            class="shop-save-section bg-white relative z-10 p30">
            <div class="shop-save">
              <SaveAndShop :chevron-left="chevronLeft" />
            </div>
          </div>
          <div v-if="!isSingleItem" class="current-cause-section bg-white relative z-10 p30">
            <div class="current-cause">
              <div class="flex items-end">
                <h3
                  class="flex-grow grow-color-text text-content font-bold text-20 tracking-normal leading-tight pr-2">
                  <span class="text-primary">
                    {{ $t("My") }}
                  </span>
                  <span class="text-secondary">{{ $t("Charity") }}</span>
                </h3>
                <router-link :to="`npos`">
                  <span class="flex text-content text-14">
                    {{ $t("Change") }}
                    <svg class="icon-color back-icon ml-1 feather feather-arrow-right" fill="none" height="24"
                      stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <line x1="5" x2="19" y1="12" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                    <!-- <img class="back-icon ml-1" :srcset="`${chevronLeft}, ${chevronLeft}`" :src="`${chevronLeft}`"
                      alt="Thrive" width="auto" height="auto" /> -->
                  </span>
                </router-link>
              </div>
              <p class="text-subtitle tracking-normal text-14 text-text opacity-60">
                Support our charity partner in need. Every penny counts !
              </p>
              <template v-if="hasCauses">
                <router-link v-for="cause in causes" :to="`npos/${cause.id}`" :key="cause.id">
                  <CauseItem :click-handler="clickCause" :cause="cause" view="block" :is-select="false" :key="cause.id"
                    :isDashboard="true">
                  </CauseItem>
                </router-link>
              </template>
            </div>
            <div class="give-extra-section mb-16">
              <Extra />
            </div>
            <!-- Invite a friend -->
            <Share />
            <div class="app-info-title text-center">
              <p class="app-title text-14">
                Powered by
                <span class="text-primary">THRIVE | Initiative</span>
              </p>
            </div>
          </div>
        </div>
      </template>
      <Navigation :causeRedirectUrl="causeRedirectUrl" />
    </div>
  </div>
</template>

<script>
// import Navigation from "../components/Navigation/Navigation";
import Close from '../components/UI/Close.vue';
import GoogleMap from "../components/GoogleMap/GoogleMap";
import Giving from "../components/Giving/Giving_new.vue";
import CauseItem from "../components/Cause/CauseItem";
import Extra from "../components/Giving/Extra_new.vue";
import Impact from "../components/Giving/Impact";
import AppFilter from "../components/Filters/AppFilter";
import UserAvatar from "../components/Icons/UserAvatar";
import mixins from "../config/mixins";
import SvgIcon from "../components/UI/SvgIcon";
import PaymentModal from "../components/Modal/PaymentModal";
import SaveAndShop from "../components/Dashboard/SaveAndShop.vue";
import PartnerSingle from '../components/Partners/PartnerSingle.vue'
import Navigation from "../components/Navigation/NewNavigation.vue";
import VideoModel from "../components/Modal/VideoModel.vue";
import DonationInstruction from "../components/Giving/DonationInstruction";
import CurrentLocation from '../components/Location/CurrentLocation.vue'
import Share from '../components/Dashboard/Share.vue';
export default {
  name: "Dashboard",

  mixins: [mixins.npos, mixins.plaid, mixins.location, mixins.retailers],

  components: {
    VideoModel,
    SvgIcon,
    UserAvatar,
    Impact,
    Extra,
    CauseItem,
    Giving,
    GoogleMap,
    AppFilter,
    PaymentModal,
    SaveAndShop,
    PartnerSingle,
    Navigation,
    DonationInstruction,
    Close,
    CurrentLocation,
    Share
  },

  data() {
    return {
      causes: [],
      causesMap: [],
      hasCauses: false,
      miles: 1,
      filterCategory: [],
      causeSingle: {},
      tagActive: null,
      searchTitle: "",
      monthDonation: 0,
      retailersMap: [],
      showModel: false,
      causeRedirectUrl: "",
      isDonationInstructionShow: false,
      isCardDeclined: false,
      isLoginRequired: false
    };
  },

  // watch: {
  //   "$store.state.userLocation": function () {
  //     this.getPartnersInMyLocation();
  //   }
  // },

  async created() {
    await this.findPrimaryLocation()
    await this.getLocation()
    this.$checkAvatar(this.$user("has_avatar"));
  },

  mounted() {
    this.$setState("showGoogleMap", false);
    this.$setState("showAppFilters", false);
    this.$setState("isNavigation", true);
    this.getUserNpos();
    this.$scrollToTop();
    this.WhichUser();
  },

  computed: {
    corporationTitle: function () {
      const corpData = this.$getState("corporation");
      if (!!corpData.title && corpData.title.length) {
        return this.getLocalizationData(corpData.title);
      }
      return "";
    },
    corporationLogo: function () {
      const corpData = this.$getState("corporation");
      if (!!corpData.logo && corpData.logo) {
        return this.getNposImage(corpData.logo);
      }
      return "";
    },
    backgroundSrc() {
      return `${this.$store.state.appUrl}/img/pwa/login/login-logo@2x.png`
    },
    logo() {
      return `${this.$store.state.appUrl}/img/pwa/login/play-button.svg`
    },
    backIcon() {
      return `${this.$store.state.appUrl}/img/pwa/dashboard-icons/i-icon.svg`
    },
    chevronLeft() {
      return `${this.$store.state.appUrl}/img/pwa/login/chevronLeft.svg`
    },
    isSingleItem() {
      return this.$store.state.singleCause && this.$store.state.singleCause.id
    }
  },
  methods: {
    causeUrl: function (cause) {
      if (cause.length > 0) {
        this.causeRedirectUrl = `npos/${cause[0]['id']}`;
      } else {
        this.causeRedirectUrl = "npos";
      }
    },
    videoModelAction: function () {
      if (this.showModel) {
        this.showModel = false
      } else {
        this.showModel = true
      }
    },
    clickHandler: function () {
      this.recreate = 0;
      this.plaidLoad();
    },
    clickCause: function () {
      return false;
    },
    getUserNpos: function () {
      this.$http.post("user/listnpo").then(res => {
        if (res && res.status !== undefined && res.status) {
          if (res.data.npo !== undefined) {
            this.causes = res.data.npo;
            this.causeUrl(this.causes);
            if (this.causes && this.causes.length > 0) {
              this.hasCauses = true;
            }
          }
        }
      });
    },
    getShowDonationInstruction: function () {

    },
    changeFilterData: function (miles, category) {
      this.miles = miles;
      this.filterCategory = category;
    },
    searchCausesByTitle: function (title) {
      this.searchTitle = title;
    },
    getPartnersInMyLocation: function () {
      let location = this.$getState("userLocation");
      this.$http
        .post("retailer/list", {
          limit: 100,
          location: {
            center_lat: location.lat,
            center_lng: location.lng,
            dist: 100
          }
        })
        .then(res => {
          if (res && res.status !== undefined && res.status) {
            this.retailersMap = res.data.retailers;
          }
        });
    },
    backCauseFunc() {
      this.$setState('saveSingleCause', null)
      this.$setState("typeAppFilter", "map")
      setTimeout(() => {
        var destination = document.getElementById('post')
        destination.scrollIntoView({
          behavior: 'smooth'
        });
      }, 500)

    },

    WhichUser: function () {
      let thriveAppReferral = this.$getState("referral");

      this.$http.post("user/useronline").then(data => {
        if (data.data.plaid_env == "development") {
          this.$store.commit("setPaymentModal", true);
        }
      });
    },
    donationInstructionAction: function () {
      if (this.isDonationInstructionShow) {
        this.isDonationInstructionShow = false
      }
      else {
        this.isDonationInstructionShow = true
      }
    },
  }
};
</script>
